<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title class="headline primary">
        <span id='chatHeaderName'>Чат</span>
        <span class="close-arrow" 
          ><v-list-item-title> 
            <v-icon medium color="white"  @click="closePopup()">close</v-icon> 
          </v-list-item-title>
        </span>
      </v-card-title>

      <Chat
        :chatId="popupContext.chatId"
        :fromUser="popupContext.user"
        :toUser="popupContext.student"
      ></Chat>
    </v-card>
  </v-dialog>
</template>

<script>
import popupEnum from '@/enums/popupEnum';
import PopupEventEnum from '@/enums/PopupEventEnum';
import Chat from '@/components/View/Chat/Chat';

export default {
  name: popupEnum.CHAT_POPUP,
  components: { Chat },
  props: {
    popupContext: {
      type: Object,
      requred: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  watch: {
    dialog(val) {
      const type = val ? PopupEventEnum.OPEN_POPUP : PopupEventEnum.CLOSE_POPUP;
      this.$emit('popupEvent', {
        type,
      });
    },
  },
  computed: {},
  mounted() {},
  destroyed() {
    this.closePopup();
  },
  methods: {
    closePopup() {
      this.dialog = false;
    },
  },
};
</script>

<style>
:root {
  /* Track */
  /* Handle */
}
:root ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
:root ::-webkit-scrollbar-track {
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
:root ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 3px;
  border-radius: 3px;
  background: #117973;
}
.close-arrow {
  position: relative;
  margin-left: auto;
}

.v-list.v-sheet.theme--light {
  padding: 0;
}
#chatHeaderName {
    color: white;
    font-family: 'Open Sans';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 33px;
    letter-spacing: 0em;
    text-align: left;

}
</style>
